'use client';

import React from 'react';
import { PrimaryLink } from 'components/ultrasignal/styleConstants';
import { useSearchParams } from 'next/navigation';
import LeftPanelComponent from './LeftPanelComponent';
import RightPanelComponent from './RightPanelComponent';
import { BloodVisionPageProps } from './types';
import styles from './BloodVisionPage.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

// Main container that spans full width
export const BuyComponentContainer = ({
  className,
  children,
  ...rest
}: React.ComponentPropsWithoutRef<'section'>) => (
  <section className={cx(styles.buyComponentContainer, className)} {...rest}>
    {children}
  </section>
);

const NotAvailableSection = ({ className }: { className?: string }) => {
  const searchParams = useSearchParams();

  return (
    <div className={cx(styles.notAvailableSection, className)}>
      <h1>Blood Vision</h1>
      <p>Blood Vision is currently not available in your region.</p>
      <PrimaryLink
        className={styles.primaryLink}
        href={{
          pathname: '/blood-vision',
          query: Object.fromEntries(searchParams?.entries() ?? []),
        }}
      >
        Learn more
      </PrimaryLink>
    </div>
  );
};

const BuyComponent: React.FC<BloodVisionPageProps> = (
  props: BloodVisionPageProps,
) => {
  return (
    <BuyComponentContainer id="blood-vision-buy">
      <LeftPanelComponent />
      {props.isAvailable ? <RightPanelComponent /> : null}
      {!props.isAvailable ? <NotAvailableSection /> : null}
    </BuyComponentContainer>
  );
};

export default BuyComponent;
